import styled from 'styled-components';

export const Container = styled.div`
  width: 300px;
  max-width: 100%;

  .container-feedback {
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media screen and (min-width: 768px) {
    width: 470px;
  }

  .items {
    max-height: 400px;
    overflow: auto;
  }

  .header {
    padding-bottom: 10px;
    margin-bottom: 20px;
    border-bottom: solid 1px rgba(0, 0, 0, 0.079);
    font-weight: 400;
    font-size: 1.1rem;
  }

  .footer {
    span {
      font-size: 0.91rem;
      color: rgb(24, 83, 53);
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
